import React from "react";
import { Container, Alert } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router";
import { useTheme } from "components/shared/ThemeProvider";

const UnauthorizedException = () => {
    const nav = useNavigate();
    const { pathname } = useLocation();
    const { isDarkMode } = useTheme();

    const onClick = () => {
        nav("/account/signin", {
            replace: true,
            state: { returnUrl: pathname },
        });
    };

    return (
        <Container>
            <Alert variant="danger" className="mt-3">
                You have not signed in. Please{" "}
                <Alert.Link
                    onClick={onClick}
                    className={`fw-bold text-decoration-underline ${
                        isDarkMode ? "text-white" : ""
                    }`}
                    style={{
                        cursor: "pointer",
                        ...(isDarkMode && { color: "white" }),
                    }}
                >
                    Sign In
                </Alert.Link>
            </Alert>
        </Container>
    );
};

export default UnauthorizedException;
